'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState, } from 'react';
import { useDismissablePopover } from '../hooks/index.js';
export function HeaderDropdown({ label, trigger, align = 'right', className, children, }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    useDismissablePopover(ref, open, () => setOpen(false), { pointerEvent: 'pointerdown' });
    // Close after any item activates — items are anchors or buttons; a click on
    // either is "I picked something, dismiss the menu." Keep raw text inside an
    // item from triggering close so labels can wrap a non-interactive element.
    const closeOnItemActivate = (e) => {
        if (e.target.closest('a, button'))
            setOpen(false);
    };
    const closeOnItemKeyActivate = (e) => {
        if ((e.key === 'Enter' || e.key === ' ') && e.target.closest('a, button')) {
            // Item handles activation; just dismiss next tick.
            setOpen(false);
        }
    };
    return (_jsxs("div", { ref: ref, className: ['tf-header-menu', className].filter(Boolean).join(' '), children: [_jsx("button", { type: "button", className: "tf-header-menu-trigger", "aria-haspopup": "menu", "aria-expanded": open, "aria-label": label, onClick: () => setOpen((prev) => !prev), children: trigger }), open && (_jsx("div", { role: "menu", "aria-label": label, className: `tf-header-menu-popover tf-header-menu-popover-${align}`, onClick: closeOnItemActivate, onKeyDown: closeOnItemKeyActivate, children: children }))] }));
}
//# sourceMappingURL=dropdown.js.map